import { useMutation, useIsMutating } from '@tanstack/react-query';
import { RcFile } from 'antd/es/upload';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { ClassifierUrl } from './ClassifierUrl';
import { ClassifierFormDataType, ClassifierSchema } from '../schema';
import { ClassifierUploadSection } from './ClassifierUploadSection';

interface IArgs {
  id?: number;
  sections: ClassifierUploadSection[];
  file: string | Blob | RcFile;
}

const mutationKey = ['classifierUpload'] as const;

export const useMutateClassifierUpload = (
  onProgress?: (progress: number) => void,
) =>
  useMutation<Partial<ClassifierFormDataType>, ApiErrorResponse, IArgs>({
    mutationKey,
    mutationFn: ({ sections, ...args }) =>
      apiClient
        .post(
          ClassifierUrl.CLASSIFIER_UPLOAD,
          {
            ...args,
            sections: sections.join(','),
          },
          {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progress) => {
              if (!progress.total) {
                return;
              }
              onProgress?.((progress.loaded / progress.total) * 100);
            },
          },
        )
        .then((response) =>
          ClassifierSchema.parseUploadFormData(response.data, sections),
        ),
  });

export const useIsClassifierUploading = () => useIsMutating({ mutationKey });
